import React, { ReactNode, createContext, useContext } from "react";
import { IconButton, Icons, Modal, Text } from "@pushpress/shared-components";
import styles from "./PanelModal.module.scss";

export interface PanelModalProps {
  visible: boolean;
  children?: ReactNode;
  onClose: VoidFunction;
  width?: string | number;
}

export interface PanelModalHeaderProps {
  title: string;
}

export interface PanelModalBodyProps {
  message?: string;
  children?: ReactNode;
}

export interface PanelModalFooterProps {
  children?: ReactNode;
}

const PanelModalContext = createContext<Partial<PanelModalProps>>({});

function PanelModal(props: PanelModalProps) {
  const { visible, children, onClose, width = "800px" } = props;

  return (
    <PanelModalContext.Provider value={props}>
      <Modal
        visible={visible}
        closeModal={onClose}
        disableClickAway
        disableEscapeKeyDown
      >
        <div style={{ width }} className={styles.root}>
          {children}
        </div>
      </Modal>
    </PanelModalContext.Provider>
  );
}

function PanelModalHeader(props: PanelModalHeaderProps) {
  const { title } = props;
  const { onClose } = useContext(PanelModalContext);
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <Text variant="heading-4" color="wolf-800">
          {title}
        </Text>
      </div>
      <div className={styles.close}>
        <IconButton icon={Icons.X} onClick={onClose} />
      </div>
    </div>
  );
}

function PanelModalBody(props: PanelModalBodyProps) {
  const { children, message } = props;
  return (
    <div className={styles.body}>
      <Text component="p" variant="body-lg" className={styles.message}>
        {message}
      </Text>
      {children}
    </div>
  );
}

function PanelModalFooter(props: PanelModalFooterProps) {
  const { children } = props;
  return <div className={styles.footer}>{children}</div>;
}

PanelModal.Header = PanelModalHeader;
PanelModal.Body = PanelModalBody;
PanelModal.Footer = PanelModalFooter;

export default PanelModal;
